
<template>
   <div class="helper row">
            <div class="select-loader">
              <content-loader
                :height="30"
                :width="173"
                 primaryColor="#ebebeb"
                secondaryColor="#f5f5f5"
                >
                <rect x="0" y="0" rx="3" ry="3" width="173" height="30" />
              </content-loader>
            </div>

            <div class="count-text">
                <div class="count-loader">
                  <content-loader
                    :height="13"
                    :width="98"
                    primaryColor="#ebebeb"
                    secondaryColor="#f5f5f5"
                    >
                    <rect x="0" y="0" rx="3" ry="3" width="98" height="13" />
                  </content-loader>
                </div>
            </div>
        </div>
</template>

<script>
export default {
  name: "OfferPreload"
};
</script>

<style lang="scss">
.select-loader {
  margin-right: 20px;
}
.count-loader svg {
  height: 13px;
  width: 98px;
}
.select-loader svg {
  width: 173px;
  height: 30px;
}
</style>
